import { useState } from 'react'

import { initRequestParamWithDaylist } from 'constants/constants'

import _ from 'lodash'
import { useCurrentStatusStore } from 'store/currentStatusStore'
import { getAPI } from 'utils/getAPI'

import type { GetShipExpectedShipExpectedGetRequest, ResponseResult, ShipExpecteds } from 'api-client'
import type { ErrorResponse } from 'types/types'

export const useShipExpected = () => {
  const [shipExpected, setShipExpected] = useState<ShipExpecteds>(initRequestParamWithDaylist)
  const [isLoading, setIsLoading] = useState(false)
  const [result, setResult] = useState<ResponseResult | undefined>(undefined)
  const { setCurrentStatuses } = useCurrentStatusStore()

  const fetchShipExpected = async (searchParam: GetShipExpectedShipExpectedGetRequest) => {
    setShipExpected(initRequestParamWithDaylist)
    setResult(undefined)
    setIsLoading(true)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.getShipExpectedShipExpectedGet({
        companyId: searchParam.companyId,
        centerId: searchParam.centerId || undefined,
        viewDateType: searchParam.viewDateType || undefined,
        viewUnitType: searchParam.viewUnitType || undefined,
        itemCode: searchParam.itemCode || undefined,
      })

      // MUI DataGridのTreeData形式に対応するため、listに親のtreepassフィールドを追加する
      setShipExpected({
        ...response.data,
        list: _.map(response.data.list, (value) => ({
          ...value,
          // TreeData形式に必要なユニークID
          id: `${value.itemCode}${value.centerId}`,
          // TreeData形式を有効にするデータパス
          ///  倉庫別出荷予測
          treepassItem: [`${value.itemName} (ID：${value.orgItemCode})`],
          /// 商品別出荷予測
          treepassCenter: [`${value.centerName} (ID：${value.centerId})`],
          // TreeDataにおいて親であるかないかのフラグ
          rootpass: true,
          systemDate: response.result.systemDate,
        })),
      })
      setResult(response.result)
      setCurrentStatuses(response.result.systemInfo?.sysCurrentStatus)
      return response
    } catch (e) {
      const error = e as ErrorResponse
      setResult({
        status: 'error',
        message: error.response && error.response.status === 422 ? '入力値に誤りがあります。' : `出荷予測データの取得でエラーが発生しました。`,
        systemDate: null,
        pageNo: 0,
        systemInfo: null,
      })
      return undefined
    } finally {
      setIsLoading(false)
    }
  }

  return {
    result,
    shipExpected,
    fetchShipExpected,
    isLoading,
  }
}
